import { render, staticRenderFns } from "./InstitutionsStudies.vue?vue&type=template&id=3333231b&"
import script from "./InstitutionsStudies.vue?vue&type=script&lang=js&"
export * from "./InstitutionsStudies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports